interface MappedDevelopmentData {
  img: string;
  title: string;
  url: string;
  imageAspectRatio: number;
  startingFrom: number;
}

export const mapDevelopmentResults = (
  results: any[],
  shop: any,
  shopName: string | null,
): MappedDevelopmentData[] => {
  if (!results) return [];
  return results.map((r) => {
    const img = r?.MainPhotoUrl ? r.MainPhotoUrl : '/assets/textimageplaceholder.png';

    const urlId = `${r?.OriginatingSystemName}-${r?.ListingId.replace(/-/g, '$')}`;

    let listUrl = `/explore/development-services/listings/${urlId}`;

    const siteUrl = `${window.location.protocol}//${window.location.host}`;
    if (shopName && !siteUrl.includes(shopName)) {
      // When the development belongs to the shop, always point to the shop's subdomain.
      listUrl = siteUrl.replace('://', `://${shopName}.`) + listUrl;
    } else {
      // Otherwise, always point to the americas site.
      listUrl = siteUrl + listUrl;
    }

    const address = `${r?.UnparsedAddress ? `${r?.UnparsedAddress},` : ''} ${
      r?.City ? `${r?.City},` : ''
    } ${r?.StateOrProvince ? `${r?.StateOrProvince},` : ''} ${
      r?.PostalCode ? `${r?.PostalCode},` : ''
    }`;
    const title = r?.ProjectName;
    const mappedData = {
      img,
      title: title ? title : address,
      url: listUrl,
      imageAspectRatio: 1,
      startingFrom: r?.StartingFrom || 0,
    };
    return mappedData;
  });
};
